<ng-container
  *ngIf="{
    cart: cart$ | async,
  } as content"
>
  <h2 class="cx-total">
    {{ 'cart.cartDetails.title' | cxTranslate }}
    <!-- {{ 'cartDetails.cartName' | cxTranslate: { code: content.cart?.code } }} -->
  </h2>
</ng-container>
